/**
 * @generated SignedSource<<9f58f54e0d5065d978b251d3f0ea1f5d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutLayout_preCheckoutTransaction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSteps_preCheckoutTransaction">;
  readonly " $fragmentType": "CheckoutLayout_preCheckoutTransaction";
};
export type CheckoutLayout_preCheckoutTransaction$key = {
  readonly " $data"?: CheckoutLayout_preCheckoutTransaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutLayout_preCheckoutTransaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutLayout_preCheckoutTransaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSteps_preCheckoutTransaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "50eee8b68bf8a99ee040ccafe99abce0";

export default node;
